'use client';

import type {
  ReactNode
} from 'react';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

interface ScrollRevealProps {
  children: ReactNode
  className?: string
  delayMs?: number
}

// Generic reveal-on-scroll wrapper for server components that can't call a
// hook directly (e.g. async sections) - client cards that already need
// 'use client' for other reasons call useScrollReveal themselves instead.
export default function ScrollReveal({
  children, className, delayMs = 0
}: ScrollRevealProps) {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`transition-all duration-500 ease-out ${ isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4' } ${ className ?? '' }`}
      style={delayMs ? {
        transitionDelay: `${ delayMs }ms`
      } : undefined}
    >
      {children}
    </div>
  );
}
